module.exports = __webpack_public_path__ + "static/media/left-indent-alt.aeec5e12.svg";